<template>
  <div class="page-content operators">
    <div class="row">
      <div class="col-12">
        <operator-list />
        <team-lead-operator-activities-summary />
        <operator-activities-summary page-id="operator-activities-summary-management" />
        <operator-activities page-id="operator-activities-management" />
        <operator-sign-on-off />
        <weekly-ai-scores />
        <change-user-roles />
        <operator-forms />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const OperatorList = defineAsyncComponent(() => import('./Operator/OperatorList.vue') as any);
const OperatorSignOnOff = defineAsyncComponent(() => import('./Operator/OperatorSignOnOff.vue') as any);
const OperatorActivities = defineAsyncComponent(() => import('./Operator/OperatorActivities.vue') as any);
const OperatorActivitiesSummary = defineAsyncComponent(() => import('./Operator/OperatorActivitiesSummary.vue') as any);
const TeamLeadOperatorActivitiesSummary = defineAsyncComponent(() => import('./Operator/TeamLeadOperatorActivitiesSummary.vue') as any);
const WeeklyAiScores = defineAsyncComponent(() => import('./Operator/WeeklyAiScores.vue') as any);
const ChangeUserRoles = defineAsyncComponent(() => import('./Operator/ChangeUserRoles.vue') as any);
const OperatorForms = defineAsyncComponent(() => import('./Operator/OperatorForms.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
